const normalizeAppConfigs = (appConfigs) =>
  appConfigs.reduce((configs, currVal) => {
    configs[currVal.configurationName] = {
      name: currVal.configurationName,
      value: currVal.value,
      description: currVal.description,
      type: currVal.type
    };
    return configs;
  }, {});

export default normalizeAppConfigs;
